var Overflow = /** @class */ (function () {
    function Overflow() {
    }
    Overflow.prototype.init = function (id) {
        this._element = document.getElementById(id);
        if (this._element) {
            var overflowButton = this._element.querySelector(':scope > .overflow-button');
            this._overflowSurface = document.querySelector("#".concat(overflowButton.id, "_surface>.overflow-menu"));
            this._overflowMenu = document.querySelector("#".concat(overflowButton.id, "_surface>.overflow-menu"));
            this._isHorizontal = this._element.classList.contains('horizontal');
            this.getOverflowButtonDimention(overflowButton);
            new ResizeObserver(this.onSizeChanged.bind(this))
                .observe(this._element);
            this._mutaionObserver = new MutationObserver(this.onSurfaceContentChanged.bind(this));
        }
        this.checkOverflow();
    };
    Overflow.prototype.checkOverflow = function () {
        try {
            this.disconnectMutionObserver();
            var children = Array.from(this._element.children)
                .filter(function (child) { return !child.classList.contains('overflow-button'); });
            var overflowMenuChildren = Array.from(this._overflowMenu.children);
            this.clearOverflowingItems(children);
            this.clearOverflowingItems(overflowMenuChildren);
            var firstOverflow = this.getFirstOverflowIndex(children);
            this.setOverflowingItems(firstOverflow, children);
            this.setOverflowingItems(firstOverflow, overflowMenuChildren);
        }
        catch (_a) {
        }
        finally {
            this.connectMutationObserver();
        }
    };
    Overflow.prototype.getOverflowButtonDimention = function (btn) {
        btn.style.display = 'inline-flex';
        this._overflowButtonWidth = btn.clientWidth;
        this._overflowButtonHeight = btn.clientHeight;
        btn.style.display = '';
    };
    Overflow.prototype.setOverflowingItems = function (firstOverflow, children) {
        if (firstOverflow == -1)
            return;
        for (var i = firstOverflow; i < children.length; i++) {
            var child = children[i];
            child.classList.add('overflowing');
        }
    };
    Overflow.prototype.getFirstOverflowIndex = function (children) {
        if (this._isHorizontal) {
            var paddingStart = parseInt(window.getComputedStyle(this._element, null).getPropertyValue('padding-inline-start'));
            var paddingEnd = parseInt(window.getComputedStyle(this._element, null).getPropertyValue('padding-inline-end'));
            var width = this._element.clientWidth;
            var availableWidth = width - paddingStart - paddingEnd;
            for (var i = 0; i < children.length; i++) {
                var child = children[i];
                var offsetEnd = this.getOffsetEnd(child) - paddingStart;
                if ((offsetEnd + this._overflowButtonWidth) > availableWidth) {
                    return i;
                }
            }
        }
        else {
            var paddingTop = parseInt(window.getComputedStyle(this._element, null).getPropertyValue('padding-top'));
            var paddingBottom = parseInt(window.getComputedStyle(this._element, null).getPropertyValue('padding-bottom'));
            var Height = this._element.clientHeight;
            var availableHeight = Height - paddingTop - paddingBottom;
            for (var i = 0; i < children.length; i++) {
                var child = children[i];
                var offsetEnd = child.offsetTop + child.offsetHeight - paddingTop;
                if ((offsetEnd + this._overflowButtonHeight) > availableHeight) {
                    return i;
                }
            }
        }
        return -1;
    };
    Overflow.prototype.clearOverflowingItems = function (children) {
        children.forEach(function (child) { return child.classList.remove('overflowing'); });
    };
    Overflow.prototype.getOffsetEnd = function (child) {
        var dir = window.getComputedStyle(child.parentElement).getPropertyValue('direction');
        var parentRect = child.parentElement.getBoundingClientRect();
        var childRect = child.getBoundingClientRect();
        if (dir === 'ltr')
            return (childRect.left - parentRect.left) + childRect.width;
        else
            return (parentRect.right - childRect.right) + childRect.width;
    };
    Overflow.prototype.onSizeChanged = function () {
        this.checkOverflow();
    };
    Overflow.prototype.onSurfaceContentChanged = function () {
        //console.log('content changed.');
        this.checkOverflow();
    };
    Overflow.prototype.disconnectMutionObserver = function () {
        if (this._mutaionObserver) {
            this._mutaionObserver.disconnect();
        }
    };
    Overflow.prototype.connectMutationObserver = function () {
        this._mutaionObserver.observe(this._overflowSurface, { attributes: true, childList: true, subtree: true });
    };
    Overflow.create = function () {
        return new Overflow();
    };
    return Overflow;
}());
export { Overflow };
